// extracted by mini-css-extract-plugin
export var container = "_5w-1";
export var editor = "_5w-2";
export var resizable = "_5w-3";
export var wrapper = "_5w-0";